import React, { useState, useEffect } from 'react';
import { useReservations } from '../ReservationContext';

const ReservationModal = ({ isOpen, mode, reservation, onClose }) => {
  const { loading, createReservation, selectedDate } = useReservations();

  const [formData, setFormData] = useState({
    date: selectedDate,
    time: '18:00',
    party_size: 2,
    customer_name: '',
    customer_phone: '',
    customer_email: '',
    special_requests: '',
    source: 'admin',
  });

  useEffect(() => {
    if (mode === 'edit' && reservation) {
      setFormData({
        date: reservation.reservation_date,
        time: reservation.reservation_time,
        party_size: reservation.party_size,
        customer_name: reservation.customer_name,
        customer_phone: reservation.customer_phone,
        customer_email: reservation.customer_email || '',
        special_requests: reservation.special_requests || '',
        source: reservation.source,
      });
    } else {
      setFormData({
        date: selectedDate,
        time: '18:00',
        party_size: 2,
        customer_name: '',
        customer_phone: '',
        customer_email: '',
        special_requests: '',
        source: 'admin',
      });
    }
  }, [mode, reservation, selectedDate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await createReservation(formData);
    if (success) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{mode === 'create' ? 'New Reservation' : 'Edit Reservation'}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form className="reservation-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Date *</label>
              <input
                type="date"
                value={formData.date}
                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label>Time *</label>
              <input
                type="time"
                value={formData.time}
                onChange={(e) => setFormData({ ...formData, time: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Party Size *</label>
              <input
                type="number"
                min="1"
                max="20"
                value={formData.party_size}
                onChange={(e) => setFormData({ ...formData, party_size: parseInt(e.target.value) })}
                required
              />
            </div>
            <div className="form-group">
              <label>Source</label>
              <select
                value={formData.source}
                onChange={(e) => setFormData({ ...formData, source: e.target.value })}
              >
                <option value="admin">Admin</option>
                <option value="phone">Phone</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Guest Name *</label>
            <input
              type="text"
              value={formData.customer_name}
              onChange={(e) => setFormData({ ...formData, customer_name: e.target.value })}
              placeholder="Guest name"
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Phone *</label>
              <input
                type="tel"
                value={formData.customer_phone}
                onChange={(e) => setFormData({ ...formData, customer_phone: e.target.value })}
                placeholder="(555) 555-5555"
                required
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={formData.customer_email}
                onChange={(e) => setFormData({ ...formData, customer_email: e.target.value })}
                placeholder="email@example.com"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Special Requests</label>
            <textarea
              value={formData.special_requests}
              onChange={(e) => setFormData({ ...formData, special_requests: e.target.value })}
              placeholder="Allergies, special occasions, seating preferences..."
              rows="3"
            />
          </div>

          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving...' : 'Save Reservation'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReservationModal;
